<template>
  <div class='pay_manage_main'>
    <div class='pay_manage_title'>
      <span class='title'>支付信息</span>
    </div>
    <ul class='manage_header' v-if='list.zaofee'>
      <li class='header_item'>
        <h5>早餐营收</h5>
        <p class='price'>
          {{ list.zaofee.toFixed(2) }}元/{{ list.zaotimes }}单
        </p>
        <!-- <p class="price">{{ list[0].sum1 }}元/{{ list[0].count1 }}单</p> -->
      </li>
      <li class='header_item'>
        <h5>午餐营收</h5>
        <p class='price'>{{ list.wufee.toFixed(2) }}元/{{ list.wutimes }}单</p>
      </li>
      <li class='header_item'>
        <h5>晚餐营收</h5>
        <p class='price'>
          {{ list.wanfee.toFixed(2) }}元/{{ list.wantimes }}单
        </p>
      </li>
      <li class='header_item'>
        <h5>当天营收</h5>
        <p class='price'>
          {{ list.sumfee.toFixed(2) }}元/{{ list.alltimes }}单
        </p>
      </li>
    </ul>
    <div class='manage_btn' @click='opendialogVisible'>
      <div class='btn'>
        <img src='../../../assets/paymentimg/pay_btn.png' alt='' />
        <span>支付管理</span>
      </div>
    </div>
    <div class='manage_table_container'>
      <el-table
        ref='multipleTable'
        :data='tableDate'
        tooltip-effect='dark'
        highlight-current-row
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column type='selection' width='50' align='center'>
        </el-table-column>
        <el-table-column
          type='index'
          width='70'
          prop='order'
          label='序号'
          align='center'
        ></el-table-column>
        <el-table-column prop='customerName' label='姓名' align='center'>
        </el-table-column>
        <el-table-column prop='foodNameNumber' label='套餐' align='center'>
        </el-table-column>
        <el-table-column
          prop='paymentAmount'
          label='套餐金额'
          align='center'
        >
        </el-table-column>
        <el-table-column prop='actualPayment' label='实际支付金额' align='center'>
        </el-table-column>
        <el-table-column prop='subsidyAmount' label='补贴金额' align='center'>
        </el-table-column>
        <el-table-column prop='payType' label='支付方式' align='center'>
          <template slot-scope='scope'>
            <span v-if="scope.row.payType == '1'">人脸识别</span>
            <span v-if="scope.row.payType == '2'">支付宝支付</span>
            <span v-if="scope.row.payType == '3'">微信支付</span>
            <span v-if="scope.row.payType == '4'">现金支付</span>
          </template>
        </el-table-column>

        <el-table-column
          prop='payTime'
          label='支付时间'
          width='200'
          align='center'
        >
        </el-table-column>
      </el-table>
      <div class='pagination_container'>
        <el-pagination
          @size-change='handleSizeChange'
          @current-change='handleCurrentChange'
          :page-sizes='[10, 20, 50, 100]'
          :page-size='10'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title='支付'
      :visible.sync='dialogVisible'
      width='990px'
      class='dialog_container'
      @close='dialogVisibleClose'
    >
      <div class='dialog_content'>
        <el-row :gutter='30'>
          <el-col :span='6'>
            <h3>姓名</h3>
            <el-input v-model='username' placeholder='请输入姓名'
            >
              <el-button
                slot='append'
                icon='el-icon-search'
                @click='lookRY'
              ></el-button
              >
            </el-input>
          </el-col>
          <el-col :span='6'>
            <h3>餐别</h3>
            <!-- 这里是监听所选中的option -->
            <el-select
              v-model='meal'
              placeholder='请选择餐别'
              @change='foodChange'
            >
              <el-option
                v-for='item in menuList'
                :key='item.id'
                :label='item.label'
                :value='item.id'
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span='6'>
            <h3>金额</h3>
            <el-input v-model='price' :disabled='true' placeholder='请输入姓名'></el-input>
          </el-col>
          <el-col :span='6'>
            <h3>支付方式</h3>
            <el-select
              v-model='paymentType'
              popper-class='payment_list_class'
              placeholder='请选择支付方式'
              @change='paymentTypeChange'
              @visible-change='choosePaymentType'
            >
              <div slot='empty' style='display: none'></div>
              <!-- <el-option
                v-for="item in paymentTypeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option> -->
            </el-select>
          </el-col>
        </el-row>
        <!-- 菜单表 -->
        <el-table :data='foodList' border class='foodtable' style='width: 100%'>
          <el-table-column type='index' label='序号' align='center' width='100'>
          </el-table-column>
          <el-table-column
            prop='foodName'
            label='菜品名称'
            align='center'
            width='240'
          >
          </el-table-column>

          <el-table-column
            prop='foodPrice'
            label='菜品价格'
            align='center'
            width='240'
          >
          </el-table-column>
          <el-table-column align='center' label='数量'>
            <template slot-scope='scope'>
              <strong @click.prevent='delNum(scope.row)'>－</strong>
              <span>{{ scope.row.foodsums }}</span>
              <strong @click.prevent='addNum(scope.row)'>＋</strong>
            </template>
          </el-table-column>
        </el-table>

        <div class='payment_list_wrapper' v-show='isPayment'>
          <ul class='payment_list'>
            <li class='payment_item' @click="shoosePayment('1')">
              <img src='../../../assets/paymentimg/r1.png' alt='' />
              <h6>人脸设备</h6>
            </li>
            <li class='payment_item' @click="shoosePayment('2')">
              <img src='../../../assets/paymentimg/r2.png' alt='' />
              <h6>支付宝支付</h6>
            </li>
            <li class='payment_item' @click="shoosePayment('3')">
              <img src='../../../assets/paymentimg/r3.png' alt='' />
              <h6>微信支付</h6>
            </li>
            <li class='payment_item' @click="shoosePayment('4')">
              <img src='../../../assets/paymentimg/r4.png' alt='' />
              <h6>现金支付</h6>
            </li>
          </ul>
        </div>
      </div>
      <span slot='footer' class='dialog-footer'>
        <el-button type='primary' @click='fukuan'>确 定</el-button>
        <el-button @click='dialogVisible = false'>取 消</el-button>
      </span>
    </el-dialog>

    <!-- 人员信息弹框 -->
    <el-dialog
      :title='enteringLRTitle'
      :visible.sync='enteringLYDialog'
      width='60%'
      class='dialog_container'
      @close='enteringLRClose'
    >
      <div class='dialog_content'>
        <el-form :inline='true' class='demo-form-inline'>
          <el-form-item>
            <el-input
              v-model='form1.customerName'
              placeholder='请输入用户姓名'
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model='form1.customerIdcard'
              placeholder='请输入身份证号码'
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type='primary' @click='query1'>查询</el-button>
            <!-- <el-button type="info" >重置</el-button> -->
          </el-form-item>
        </el-form>
        <el-table
          :data='RYTableData'
          tooltip-effect='dark'
          style='width: 100%'
          :header-cell-style="{
            background: '#e6e6e6',
            color: '#000',
          }"
          border
          @selection-change='handleSelectionChange1'
        >
          <el-table-column type='selection' width='55'></el-table-column>
          <el-table-column
            type='index'
            width='70'
            label='序号'
            align='center'
          ></el-table-column>
          <!-- <el-table-column align="center" prop="volunteerArchiveCode" label="" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column
            align='center'
            prop='customerName'
            label='用户姓名'
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            align='center'
            prop='customerPhone'
            label='手机号'
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            align='center'
            prop='customerAge'
            label='年龄'
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            align='center'
            prop='customerSex'
            label='性别'
            :show-overflow-tooltip='true'
          >
            <template slot-scope='scope'>
              <span v-if='scope.row.customerSex == 0'>男</span>
              <span v-if='scope.row.customerSex == 1'>女</span>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" prop="teamName" label="所属团队" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="detailAddress" label="居住地址" :show-overflow-tooltip="true"></el-table-column> -->
        </el-table>
        <div class='pagination_container'>
          <el-pagination
            :page-sizes='[10, 20, 50, 100]'
            :page-size='10'
            layout='total, sizes, prev, pager, next, jumper'
            :total='total3'
          ></el-pagination>
        </div>
      </div>
      <span slot='footer' class='dialog-footer'>
        <!-- <el-button type="primary" @click="saveVolunteer" >确 定</el-button>
        <el-button @click="enteringDialog = false">取 消</el-button> -->
        <el-button type='primary' @click='saveRY'>确 定</el-button>
        <el-button @click='enteringRYDialog = false'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '../../../api/requrestHttp'
import request from '@/utils/request.js'

export default {
  data() {
    return {
      form1: [],
      RYTableData: [],
      total3: 0,
      RYXQ1: [],
      timer: null,
      enteringLYDialog: false,
      enteringLRTitle: '人员信息',
      username: '', //用户姓名
      price: 0, //付款金额
      meal: 0, //菜单类型
      customerId: '',
      currentpay: '1',
      menuList: [
        //菜单类别列表
        {
          id: 0,
          label: '未选择'
        },
        {
          id: 1,
          label: '早餐'
        },
        {
          id: 2,
          label: '中餐'
        },
        {
          id: 3,
          label: '晚餐'
        }
      ],
      foodList: [],
      strId: '', //菜单id
      paymentType: '', //支付类型
      paymentTypeList: [
        //支付类型列表
        {
          id: 1,
          label: '人脸设备'
        },
        {
          id: 2,
          label: '支付宝'
        },
        {
          id: 3,
          label: '微信'
        },
        {
          id: 4,
          label: '现金'
        }
      ],
      tableDate: [],
      dialogVisible: false, //是否模态框
      isPayment: false, //是否显示支付列表
      pageNo: 1,
      pageSize: 10,
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      total: 0,
      list: [
        {
          sum: ''
        }
      ],
      count: '',
      currentData: null
    }
  },
  methods: {
    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.showList()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: 'success'
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.showList()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: 'success'
      })
    },
    // value 是 select选中的值
    foodChange(value) {
      let params = {
        pageSize: 10,
        meal: value
      }
      request({
        url: '/sqyl/admin/weeklyMenu/findTodayFoodbymeal',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        if (res.content == 'null' || res.content == null) {
          this.price = 0
          this.foodList = []
        } else {
          this.meal = res.content[0].meal
          // 这个meal 数数字 select选中的值
          console.log(this.meal)
          this.price = res.content[0].foodPrice
          this.foodList = res.content
          console.log(this.foodList)
          var sum = 0
          for (var i = 0; i < this.foodList.length; i++) {
            sum += parseInt(this.foodList[i].foodPrice)
          }
          this.price = sum
        }
      })
    },
    delNum(row) {
      if (row.foodsums < 1) {
        row.foodsums = 0
      } else {
        row.foodsums = row.foodsums - 1
        var sum = 0
        for (var i = 0; i < this.foodList.length; i++) {
          sum +=
            parseInt(this.foodList[i].foodPrice) * this.foodList[i].foodsums
        }
        this.price = sum
      }
    },
    addNum(row) {
      console.log(row)
      row.foodsums = row.foodsums + 1
      var sum = 0
      for (var i = 0; i < this.foodList.length; i++) {
        sum += parseInt(this.foodList[i].foodPrice) * this.foodList[i].foodsums
      }
      this.price = sum
      console.log(this.price)
      console.log(this.foodList)
    },
    fukuan() {
      var str = ''
      var foodNameNumber = ''
      var zcfoodNumber = ''
      for (var i = 0; i < this.foodList.length; i++) {
        var a = i + 1
        if (this.foodList[i].foodsums >= 1) {
          for (var j = 0; j < this.foodList[i].foodsums; j++) {
            str = str.concat(this.foodList[i].id) + ','
            foodNameNumber = foodNameNumber.concat(this.foodList[i].foodName) + ','
            zcfoodNumber = zcfoodNumber.concat(this.foodList[i].foodsums) + ','
          }
        }
      }
      str = str.substring(0, str.length - 1)
      this.strId = str
      if (this.meal !== 0) {
        let params = {
          customerId: this.customerId,
          orderType: this.meal,
          paymentAmount: this.price,
          payType: this.currentpay,
          intoCostType: 0,
          isTake: 1,
          zcfoodId: this.strId,
          foodNameNumber: foodNameNumber,
          zcfoodNumber: zcfoodNumber
        }
        params = Object.assign({}, params)
        if (this.foodList.length == 0) {
          this.$message.error('菜品信息不可为空')
          return
        } else {
          request({
            url: '/sqyl/admin/pay/payMoney',
            method: 'POST',
            data: params
          }).then((res) => {
            console.log(res)
            this.dialogVisible = false
            this.showList()
            this.sumNum()
            this.$message({
              message: `新增成功`,
              type: 'success'
            })
            // if (res.content != null) {
            //     this.RYTableData = res.content.list;
            //     this.total = res.content.count;
            // } else {
            //     this.RYTableData = [];
            // }
          })
        }

      } else {
        this.$message({
          message: `请选择餐别`,
          type: 'error'
        })
      }
    },
    // 查询
    async query1() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form1,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo')).stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo')).shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/customer/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        // console.log(res);
        if (res.content != null) {
          this.RYTableData = res.content.list
          this.total = res.content.count
        } else {
          this.RYTableData = []
        }
      })
    },
    // 人员信息
    enteringLRClose() {
    },
    handleSelectionChange1(data) {
      this.RYXQ1 = data
      console.log(this.RYXQ1)
    },
    //用户列表
    async showlist1() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo')).stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo')).shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/customer/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        if (res.content != null) {
          this.RYTableData = res.content.list
          this.total = res.content.count
        }
        console.log(this.RYTableData)
      })
    },
    async saveRY() {
      // console.log(this.RYXQ1.length)
      console.log(this.RYXQ1)
      console.log(this.RYXQ1[0])
      if (this.RYXQ1) {
        if (this.RYXQ1.length != 1) {
          this.$message({
            message: `请选择一个人员`,
            type: 'error'
          })
        } else {
          // let ry = this.RYXQ1[0];
          this.username = this.RYXQ1[0].customerName
          this.customerId = this.RYXQ1[0].id
          // this.addForm.customerIdcard = this.RYXQ1[0].customerIdcard
          // this.addForm.customerSex = this.RYXQ1[0].customerSex
          // this.addForm.customerBirthday = this.RYXQ1[0].customerBirthday
          // this.addForm.customerPhoto = this.RYXQ1[0].customerPhoto
          // console.log(ry.economySource,'ry.economySource')
          // this.addForm = {
          //     ...ry,
          //     economySource: ry.economySource.split(","),
          //     orderType: [],
          //     // provinceId: String(ry.provinceId),
          //     // cityid: String(ry.cityid),
          //     // zoneid: String(ry.zoneid),
          //     // streetid: String(ry.streetid),
          //     // shequid: String(ry.shequid),
          //     orderBalance:ry.totalMoney
          // };

          this.enteringLYDialog = false
          // let self = this
          // let jsonTemp = {...this.addForm}
          // if(!jsonTemp.provinceId) return
          // let city = await self.getDistrict(jsonTemp.provinceId);
          // self.cityList = city.districtList;
          // if(!jsonTemp.cityid) return
          // let area = await self.getDistrict(jsonTemp.cityid);
          // self.areaList = area.districtList;
          // if(!jsonTemp.zoneid)return
          // let street = await self.getDistrict(jsonTemp.zoneid.replace(/.$/, ""),jsonTemp);
          // self.streetList = street.districtList;
          // if(!jsonTemp.streetid)return
          // this.streetChange(jsonTemp.streetid, true)
        }
      }
    },
    lookRY() {
      this.enteringLYDialog = true
      this.showlist1()
    },
    // 显示模态框
    opendialogVisible() {
      let _this = this
      this.dialogVisible = true
      console.log(1)
      let params = {
        pageSize: 10,
        meal: this.meal
      }
      request({
        url: '/sqyl/admin/weeklyMenu/findTodayFoodbymeal',
        method: 'POST',
        data: params
      }).then((res) => {
        if (res.content == 'null' || res.content == null) {
          this.price = 0
        } else {
          this.meal = res.content[0].meal
          this.price = res.content[0].foodPrice
        }
        // this.paymentType = 1
        // let obj = {
        //   1: "人脸识别",
        //   2: "支付宝支付",
        //   3: "微信支付",
        //   4: "现金支付",
        // };
        // this.currentpay = 1;
        this.paymentType = '人脸识别'
        request({
          url: '/sqyl/admin/weeklyMenu/startFace',
          method: 'POST',
          data: ''
        }).then((res) => {
          //      _this.timer = setInterval(() => {
          //     // console.log(123);
          //     _this.$http
          //         .request({
          //             url: "/sqyl/admin/zcfaceRecord/findlist",
          //             method: "POST",
          //             data: {
          //                 pageSize: 1000,
          //                 pageNo: 1,
          //             },
          //         })
          //         .then((res) => {
          //             if (res.code == 200) {
          //                 if (res.content && res.content.list) {
          //                   let data = res.content.list[0]
          //                   this.currentData = data
          //                   this.username = data.customerName
          //                   clearInterval(_this.timer);
          //                   console.log(this.currentData.customerId)
          //                   console.log(this.currentData)
          //                   this.customerId = this.currentData.customerId
          //                 }
          //             }
          //         });
          // }, 1000);
        })
      })
    },
    //显示支付方式
    choosePaymentType(val) {
      this.isPayment = val
    },

    paymentTypeChange() {
      clearInterval(this.timer)
      console.log(1)
    },
    dialogVisibleClose() {
      clearInterval(this.timer)
      this.username = ''
      this.meal = 0
      this.price = 0
      this.paymentType = ''
      this.customerId = ''
    },
    //展开支付方式
    shoosePayment(val) {
      clearInterval(this.timer)
      let _this = this
      let obj = {
        1: '人脸识别',
        2: '支付宝支付',
        3: '微信支付',
        4: '现金支付'
      }
      this.currentpay = val
      this.paymentType = obj[val]
      console.log(this.paymentType)
      if (this.currentpay == '1') {
        request({
          url: '/sqyl/admin/weeklyMenu/startFace',
          method: 'POST',
          data: ''
        }).then((res) => {
          //      _this.timer = setInterval(() => {
          //     console.log(123);
          //     _this.$http
          //         .request({
          //             url: "/sqyl/admin/zcfaceRecord/findlist",
          //             method: "POST",
          //             data: {
          //                 pageSize: 1000,
          //                 pageNo: 1,
          //             },
          //         })
          //         .then((res) => {
          //             if (res.code == 200) {
          //                 if (res.content && res.content.list) {
          //                   let data = res.content.list[0]
          //                   this.currentData = data
          //                   this.username = data.customerName
          //                   clearInterval(_this.timer);
          //                   console.log(this.currentData.customerId)
          //                   console.log(this.currentData)
          //                   this.customerId = this.currentData.customerId
          //                 }
          //             }
          //         });
          // }, 1000);
        })
      }
    },

    showList() {
      post('/sqyl/admin/pay/payManage', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo')).stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo')).shequjiId
      }).then((res) => {
        // console.log(res);
        this.tableDate = res.content.list
        this.total = res.content.count
      })
    },
    sumNum() {
      post('/sqyl/admin/pay/earning', {
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo')).stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo')).shequjiId
      }).then((res) => {
        if (res.content == null || res.content == 'null') {
          this.list = {
            zaofee: 0.0,
            zaotimes: 0.0,
            wufee: 0.0,
            wanfee: 0.0,
            wutimes: 0.0,
            sumfee: 0.0,
            wantimes: 0.0,
            alltimes: 0.0
          }
        } else {
          this.list = res.content
          console.log(this.list)
        }
      })
    }
  },
  created() {
  },
  mounted() {
    this.sumNum()
    this.showList()
  }
}
</script>

<style lang='less'>
@font-face {
  font-family: "Unidtrsmled";
  src: url(../assets/font/UnidreamLED.ttf);
}

.payment_list_class {
  visibility: hidden;
}

.pay_manage_main {
  padding: 30px 42px;
  background: #ffffff;

  .pay_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;

    &::after {
      position: absolute;
      left: 120px;
      right: 0;
      display: block;
      content: "";
      border-bottom: 1px solid #e4e7ed;
    }

    .title {
      box-sizing: border-box;
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #409eff;
      font-size: 14px;
      border: 1px solid #e4e7ed;
      border-bottom: none;
      border-radius: 4px 4px 0 0;
      box-sizing: border-box;
      background: #ffffff;
    }
  }

  .manage_header {
    display: flex;
    flex-wrap: wrap;

    .header_item {
      flex: 0 0 22%;
      padding: 24px 20px;
      box-sizing: border-box;
      border-radius: 5px;

      &:not(:nth-child(4n + 1)) {
        margin-left: 4%;
      }

      &:nth-child(n + 5) {
        margin-top: 24px;
      }

      &:nth-child(1) {
        background: rgba(94, 251, 212, 0.1) url("../../../assets/paymentimg/t1.png") no-repeat right 15px bottom 15px;

        .price {
          color: #58f1ca;
          font-family: Unidtrsmled;
          font-size: 36px;
        }
      }

      &:nth-child(2) {
        background: rgba(65, 192, 245, 0.1) url("../../../assets/paymentimg/t2.png") no-repeat right 15px bottom 15px;

        .price {
          color: #41c0f5;
          font-family: Unidtrsmled;
          font-size: 36px;
        }
      }

      &:nth-child(3) {
        background: rgba(120, 126, 255, 0.1) url("../../../assets/paymentimg/t3.png") no-repeat right 15px bottom 15px;

        .price {
          color: #787eff;
          font-family: Unidtrsmled;
          font-size: 36px;
        }
      }

      &:nth-child(4) {
        background: rgba(29, 193, 56, 0.1) url("../../../assets/paymentimg/t4.png") no-repeat right 15px bottom 15px;

        .price {
          color: rgba(29, 193, 56, 1);
          font-family: Unidtrsmled;
          font-size: 36px;
        }
      }

      h5 {
        margin-bottom: 30px;
        color: #000000;
        font-size: 16px;
      }

      .price {
        padding-right: 40px;
        color: #41c0f5;
        font-size: 26px;
        font-weight: 400;
        text-align: center;
      }
    }
  }

  .manage_btn {
    width: 196px;
    height: 50px;
    margin: 24px 0 12px;
    background: #3abbf6;
    cursor: pointer;

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      font-size: 20px;
      color: #ffffff;
      border-radius: 5px;

      img {
        margin-right: 18px;
      }
    }
  }

  /deep/ .pagination_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      color: #606266;
      min-width: 30px;
      height: 36px;
      line-height: 36px;
      margin: 0;
      border-radius: 0;
      border: 1px solid #dddddd;
      border-radius: none;

      &.active {
        color: #ffffff;
        background: #337ab7;
      }
    }

    .el-pagination.is-background .btn-prev {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }

    .el-pagination.is-background .btn-next {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    .el-pagination.is-background .el-pager li {
      border-left: none;
      padding: 0px 16px;
      color: #337ab7;
    }
  }

  /deep/ .dialog_container {
    .el-dialog__header {
      border-bottom: 1px solid #e5e5e5;
    }

    .dialog_content {
      .el-col {
        text-align: center;
      }

      h3 {
        padding: 42px 0 24px 0;
        text-align: center;
      }

      .el-select {
        .el-input__inner {
          width: 100%;
        }
      }

      .payment_list_wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;

        .payment_list {
          display: flex;
          padding: 12px 42px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;

          .payment_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 24px;
            cursor: pointer;

            h6 {
              margin-top: 12px;
              font-size: 16px;
            }
          }
        }
      }
    }

    .el-dialog__footer {
      background: #f5f5f5;
      padding: 8px 15px;
      border-top: 1px solid #e5e5e5;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}

.foodtable {
  text-align: center;
  margin-top: 20px;

  strong {
    display: inline-block;
    padding: 20px;
    font-size: 28px;
    cursor: pointer;
    font-weight: 700;
  }
}
</style>